




















































































































import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app'
import GiganautVue from '@/components/Shared/GiganautVue';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import PageNames from '@/router/PageNames';

@Component({
  name: 'WorkerAgencyWorkerRights',
  components: { }
})
export default class extends GiganautVue {
    
    async created() {
       await WorkerDetailsModule.getAwrSummary();
    }
    
    get loading() {
        return WorkerDetailsModule.loadingAwrSummary;
    }

    get awrSummary() {
        return WorkerDetailsModule.awrSummary;
    }
}
